import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { IconActionRefresh16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './Spinner.css';

export interface ISpinnerProps {
  size?: number;
}

export function Spinner({ size }: ISpinnerProps) {
  return (
    <div {...mergeStyles(styles['container'], { height: size, width: size })}>
      <IconActionRefresh16 color={'icon-inverted-default'} />
    </div>
  );
}
